// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Global ol styles */
.ol-selectable {
  -ms-user-select: text;
  -moz-user-select: text;
  -webkit-user-select: text;
  user-select: text;
}
/* Rotate control */
.ol-compass {
  display: inline-block;
  font-weight: normal;
  font-size: 24px;
}
`, "",{"version":3,"sources":["webpack://./package/nextgisweb/nextgisweb/webmap/nodepkg/map-component/MapComponent.less"],"names":[],"mappings":"AAAA,qBAAqB;AAoBrB;EACI,qBAAA;EACA,sBAAA;EACA,yBAAA;EACA,iBAAA;AAlBJ;AACA,mBAAmB;AAsBnB;EACI,qBAAA;EACA,mBAAA;EACA,eAAA;AApBJ","sourcesContent":["// .ol-rotate {\n//     top: 4.643em;\n//     right: auto;\n//     left: 0.5em;\n// }\n\n// .map-container {\n//     .ol-control-top-right {\n//         position: absolute;\n//         top: 16px;\n//         right: 16px;\n//     }\n//     .ol-control-top-left {\n//         position: absolute;\n//         top: 16px;\n//         left: 16px;\n//     }\n// }\n\n/* Global ol styles */\n.ol-selectable {\n    -ms-user-select: text;\n    -moz-user-select: text;\n    -webkit-user-select: text;\n    user-select: text;\n}\n\n/* Rotate control */\n\n.ol-compass {\n    display: inline-block;\n    font-weight: normal;\n    font-size: 24px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
